// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__1cGH7","title_center":"Title_title_center__3rClr"};